import { Box, Typography } from "@mui/material";
import { Modal, ModalSheetTitle } from "../modal/index.js";
import { useTranslation } from "next-i18next";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import React from "react";
export const ModalError = NiceModal.create(({ error }) => {
    const { t } = useTranslation("c-cart");
    const modal = useModal();
    const title = t("cart-error-headline", "Das hat leider nicht funktioniert");
    const message = error instanceof Error
        ? error.message
        : t("cart-error-message", "Ein unbekannter Fehler ist aufgetreten. Bitte versuche es erneut oder kontaktiere uns unter support@culinario-mortale.de");
    return (React.createElement(Modal, { label: title, open: modal.visible, onClose: modal.hide },
        React.createElement(Box, null,
            React.createElement(ModalSheetTitle, null, title),
            React.createElement(Typography, { variant: "body1", paragraph: true }, message))));
});
//# sourceMappingURL=modal-error.js.map